import { Button } from "@/components/ui/button";
import { Panel, type PanelProps } from "@/components/ui/Panel";
import { refusalDetail } from "@/services/api-client";
import { cn } from "@/lib/utils";

/**
 * What a failed read says, in the server's words where it gave any.
 *
 * Two panes wrote it each, and by the time the tone vocabulary and the surface
 * shell had reached them they differed in one thing: one was a card and one a
 * row. The shape stays a parameter because that is a real difference, and the
 * tone, the role and the wording are not.
 *
 * There is no `Notice` primitive and there need not be: a boxed alert is a
 * `Panel` with a tone and a role. It sits beside the features rather than among
 * the primitives because it reads the server's refusal wording, and
 * `components/ui` holds things that know nothing about a service.
 */
export function LoadFailure({
  error,
  fallback,
  shape,
  className,
  onRetry,
}: {
  error: unknown;
  /** What could not be loaded, said plainly, when the server said nothing. */
  fallback: string;
  shape?: PanelProps["shape"];
  className?: string;
  /** Read it again: given, the failure carries a Try again beside its words. */
  onRetry?: () => void;
}) {
  return (
    <Panel
      as="p"
      shape={shape}
      pad="tight"
      tone="destructive"
      role="alert"
      className={cn("text-[11.5px]", className)}
    >
      {refusalDetail(error, fallback)}
      {onRetry !== undefined && (
        <>
          {" "}
          <Button variant="link" onClick={onRetry}>
            Try again
          </Button>
        </>
      )}
    </Panel>
  );
}
